import React from "react";

/**
 * One labelled input row matching BiorGov styling. Used by all auth pages.
 */
const AuthField = ({ label, error, touched, ...inputProps }) => {
  const showError = touched && error;
  return (
    <div style={{ marginBottom: "1rem" }}>
      {label && (
        <label
          htmlFor={inputProps.id || inputProps.name}
          style={{
            display: "block",
            fontSize: 13,
            color: "var(--bl-text-strong)",
            marginBottom: 6,
            fontWeight: 500,
          }}
        >
          {label}
        </label>
      )}
      <input
        {...inputProps}
        id={inputProps.id || inputProps.name}
        className="bl-input"
        style={{
          borderColor: showError ? "rgba(255,93,108,0.6)" : "var(--bl-line-strong)",
          ...(inputProps.style || {}),
        }}
      />
      {showError && (
        <p style={{ marginTop: 4, fontSize: 12, color: "#ff8a98" }}>{error}</p>
      )}
    </div>
  );
};

export default AuthField;
